/**
 * Establece el titulo del documento con el sufijo "El Aguara"
 * @param {string} titulo - Titulo de la pagina
 */
export function usePageTitle(titulo) {
    if (titulo) {
        document.title = `${titulo} | El Aguara`;
    } else {
        document.title = 'El Aguara';
    }
}
